<section id="farms-section" class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-10 animate-fade-in">
  <div class="card p-6 md:p-8 border-gold/20 bg-gold/[0.02]">
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8">
      <div>
        <h3 class="font-display font-black text-2xl text-white uppercase tracking-wider">Compound Yield LP Farms</h3>
        <p class="text-text-muted text-[13.5px] mt-1.5">Stake Liquidity Pool (LP) tokens inside farms to compound yield
          ecosystem payouts.</p>
      </div>
      <button (click)="state.triggerNotification('Select a pool below to deposit your LP tokens.')"
        class="btn-gold w-full md:w-auto px-8 py-3.5 rounded-xl text-[12.5px] font-bold tracking-widest uppercase shadow-md">
        Stake Liquidity LP Tokens
      </button>
    </div>

    <div class="flex flex-col gap-4">
      @for (farm of state.farms(); track farm.pair) {
      <div
        class="bg-black/45 border border-border-primary hover:border-gold/30 p-5 rounded-2xl flex flex-col xl:flex-row justify-between items-start xl:items-center gap-6 transition-all duration-300 hover:shadow-[0_4px_20px_rgba(245,183,59,0.1)] hover:-translate-y-0.5">

        <!-- Token Info -->
        <div class="flex items-center gap-3 w-full xl:w-auto border-b border-white/[0.04] xl:border-none pb-4 xl:pb-0">
          <div class="token-badge w-10 h-10 shadow-lg" [style.background]="farm.token1Color">{{ farm.pair.charAt(0) }}
          </div>
          <div>
            <h4 class="font-display font-extrabold text-base md:text-lg text-white tracking-wide leading-none">{{
              farm.pair }}
            </h4>
            <span
              class="text-[10px] text-gold font-bold uppercase tracking-wider mt-1.5 block bg-gold/10 px-2 py-0.5 rounded w-fit">Multiplier:
              40x</span>
          </div>
        </div>

        <!-- Stats Grid -->
        <div class="grid grid-cols-3 gap-2 sm:gap-8 md:gap-16 w-full xl:w-auto text-center xl:text-left">
          <div>
            <span class="text-[9px] sm:text-[10px] text-text-dim font-bold uppercase tracking-wider block">Yield
              APR</span>
            <span class="font-display font-black text-base sm:text-lg text-gold mt-1 block">{{ farm.apr }}%</span>
          </div>
          <div>
            <span class="text-[9px] sm:text-[10px] text-text-dim font-bold uppercase tracking-wider block">Harvest
              Earned</span>
            <span class="font-bold text-white text-sm sm:text-base mt-1 block">${{ farm.earned.toLocaleString()
              }}</span>
          </div>
          <div>
            <span class="text-[9px] sm:text-[10px] text-text-dim font-bold uppercase tracking-wider block">TVL
              Capital</span>
            <span class="font-bold text-white text-sm sm:text-base mt-1 block">$18.42M</span>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-2 w-full xl:w-auto mt-2 xl:mt-0">
          <button (click)="state.triggerNotification('Harvesting farm rewards...')"
            [disabled]="!state.isWalletConnected()"
            class="btn-gold flex-1 xl:flex-none px-5 py-3 rounded-xl text-[11px] font-bold uppercase tracking-widest">
            Harvest
          </button>
          <button (click)="state.triggerNotification('LP token staked successfully!')"
            [disabled]="!state.isWalletConnected()"
            class="btn-outline flex-1 xl:flex-none px-5 py-3 rounded-xl text-[11px] font-bold uppercase tracking-widest border-white/20 hover:border-gold/50">
            Stake LP
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</section>